import React, { useState } from "react";
import { toast } from "../../components/toasts/toastStore";
import { PATH } from "../../redux/utils";

import "./PacientesPage.css";

const MAX_BYTES = 5 * 1024 * 1024;

// URL publica de la imagen guardada en (path, filename); null si no tiene.
export const fotoUrl = (item) =>
  item?.path && item?.filename ? `${PATH.replace(/\/$/, "")}/${item.path}/${item.filename}` : null;

// Contenido del banner de una card de listado: la foto si existe, si no el icono.
export function BannerFoto({ item, icon }) {
  const url = fotoUrl(item);
  return url ? (
    <img className="paq-card-banner-img" src={url} alt="" />
  ) : (
    <i className={`fa-solid ${icon} paq-card-banner-icon`} />
  );
}

// Tarjeta de foto para las paginas de detalle (va a la izquierda del contenido,
// dentro de un `.cd-info-layout`). `onUpload(file)` sube y refresca el detalle.
export default function EntidadFotoCard({ item, icon = "fa-user", canEdit, onUpload }) {
  const [subiendo, setSubiendo] = useState(false);
  const url = fotoUrl(item);

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/") || file.size > MAX_BYTES) {
      toast.warning("Selecciona una imagen de maximo 5 MB");
      return;
    }
    setSubiendo(true);
    try {
      await onUpload(file);
      toast.success("Imagen actualizada");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo subir la imagen");
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div className="cd-foto-card">
      <div className="cd-foto-frame">{url ? <img src={url} alt="" /> : <i className={`fa-solid ${icon}`} />}</div>
      {canEdit && (
        <label className={`cd-foto-btn ${subiendo ? "cd-foto-btn-disabled" : ""}`}>
          <input type="file" accept="image/*" hidden disabled={subiendo} onChange={handleChange} />
          <i className="fa-solid fa-camera" /> {subiendo ? "Subiendo..." : url ? "Cambiar imagen" : "Subir imagen"}
        </label>
      )}
    </div>
  );
}
